module.exports = __webpack_public_path__ + "static/media/header-bg.aefe05cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-bg.jpg
// module id = 181
// module chunks = 0